import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/contexts'
import { ProfileType } from '@/enum/profile-type'

export function LayoutMonitoringBackOffice() {
  const { userProfiles, signed } = useAuth()

  if (!signed) {
    return <Navigate to="/login" />
  }

  const isNotAdminOrSuperAdmin =
    !userProfiles?.includes(ProfileType.Admin) &&
    !userProfiles?.includes(ProfileType.SuperAdmin)

  if (isNotAdminOrSuperAdmin) {
    return <Navigate to="/not-allowed" replace />
  }

  return <Outlet />
}
